import { render, staticRenderFns } from "./TeacherDashboard.vue?vue&type=template&id=6c955686&"
import script from "./TeacherDashboard.vue?vue&type=script&lang=js&"
export * from "./TeacherDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports